export const GET_COUNTRY_DATA = "GET_COUNTRY_DATA"
export const SET_COUNTRY_DATA = "SET_COUNTRY_DATA"
export const GET_REPORT_DEALER_DATA = "GET_REPORT_DEALER_DATA"
export const SET_REPORT_DEALER_DATA = "SET_REPORT_DEALER_DATA"
export const GET_CONTRACTOR_REPORT_DATA = "GET_CONTRACTOR_REPORT_DATA"
export const SET_CONTRACTOR_REPORT_DATA = "SET_CONTRACTOR_REPORT_DATA"
export const GET_ALL_STATE_DATA = "GET_ALL_STATE_DATA"
export const GET_ALL_CITY_DATA = "GET_ALL_CITY_DATA"
export const GET_ALL_PIN_CODE_DATA = "GET_ALL_PIN_CODE_DATA"
export const SET_ALL_STATE_DATA = "SET_ALL_STATE_DATA"
export const SET_ALL_CITY_DATA = "SET_ALL_CITY_DATA"
export const SET_ALL_PIN_CODE_DATA = "SET_ALL_PIN_CODE_DATA"
export const GET_SELECTED_STATE_CITY_DATA = "GET_SELECTED_STATE_CITY_DATA"
export const SET_SELECTED_STATE_DATA = "SET_SELECTED_STATE_DATA"
export const SET_SELECTED_CITY_DATA = "SET_SELECTED_CITY_DATA"
export const SET_COUNTRY_REPORT_DATA = "SET_COUNTRY_REPORT_DATA"
export const GET_REPORT_VALIDATION = "GET_REPORT_VALIDATION"
export const SET_REPORT_VALIDATION = "SET_REPORT_VALIDATION"
export const GET_EXCEL_REPORT = "GET_EXCEL_REPORT"
export const SET_INTERVAL_ID = "SET_INTERVAL_ID"
export const SET_EXCEL_REPORT = "SET_EXCEL_REPORT"
export const GET_CERTIFICATE_DATA = "GET_CERTIFICATE_DATA"
export const SET_CERTIFICATE_DATA = "SET_CERTIFICATE_DATA"
export const SET_CERTIFICATE_NAME = "SET_CERTIFICATE_NAME"
export const SEARCH_CERTIFICATE_DATA = "SEARCH_CERTIFICATE_DATA";
export const SET_SEARCH_CERTIFICATE_DATA = "SET_SEARCH_CERTIFICATE_DATA";
export const SET_LOADER_FLAG = "SET_LOADER_FLAG";


